define('fukit/helpers/extend.util',['require','exports','module','underscore','marionette','../behavior/resolve.options.behavior','uikit/extra/extend.util'],function(require, exports, module) {
  //prettier-ignore
  var _                      = require('underscore'),
      Mn                     = require('marionette'),
      ResolveOptionsBehavior = require('../behavior/resolve.options.behavior'),
      UIKitExtendUtil        = require('uikit/extra/extend.util');

  var ExtendUtil = {
    extendOptionValueWithDefaults: function(optionName, defaults) {
      return function() {
        var resolvedDefaultValues;
        if (_.isFunction(defaults)) {
          resolvedDefaultValues = Mn._getValue(defaults, this);
        } else {
          resolvedDefaultValues = ResolveOptionsBehavior.resolveViewOptions(defaults, this);
        }
        var passedInOptions = Mn._getValue(this.getOption(optionName), this) || {};
        return _.extend({ model: this.getOption('model') }, resolvedDefaultValues, passedInOptions, {
          behaviors: UIKitExtendUtil.extendBehaviors(resolvedDefaultValues.behaviors, passedInOptions.behaviors),
        });
      };
    },
  };

  module.exports = ExtendUtil;
});

